import * as React from 'react';
export const robinhoodSvg = React.forwardRef(function robinhoodSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#004022',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00C805',
      d: 'm14.89 22.261-.146.048c-.94.312-2.332.795-3.58 1.37a.3.3 0 0 0-.11.12l-.084.193-.004.01c-.14.319-.333.797-.417.993l-.064.154a.062.062 0 0 0 .016.07.058.058 0 0 0 .042.018.079.079 0 0 0 .028-.006l.15-.072c.343-.162.775-.408 1.227-.624l.016-.008c.863-.409 1.835-.871 2.422-1.151 0 0 .094-.05.142-.144l.438-.88a.064.064 0 0 0-.008-.07.063.063 0 0 0-.068-.02Zm-3.506-1.365.41-.79.012-.022a54.397 54.397 0 0 1 6.899-10.073l.074-.086a.089.089 0 0 0 .01-.096.086.086 0 0 0-.086-.044l-.112.016a55.34 55.34 0 0 0-5.278.995.694.694 0 0 0-.31.188 59.199 59.199 0 0 0-3.685 4.907.433.433 0 0 0-.062.29c.012.09.287 2.201.703 3.823-1.033 2.972-1.955 6.888-1.955 6.888a.088.088 0 0 0 .012.074c.016.022.04.034.068.034h.588a.09.09 0 0 0 .084-.056l.04-.11a54.916 54.916 0 0 1 2.588-5.938Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00C805',
      d: 'm19.567 10.655-.002-.112a.087.087 0 0 0-.056-.078.088.088 0 0 0-.094.024l-.074.084a53.443 53.443 0 0 0-7.785 11.888l-.048.1a.085.085 0 0 0 .014.096.087.087 0 0 0 .094.02l.102-.042a51.288 51.288 0 0 1 5.314-1.867.404.404 0 0 0 .246-.204c.778-1.517 2.585-4.455 2.585-4.455.046-.066.034-.164.034-.164s-.31-3.512-.33-5.29Z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fill: '#00C805',
      d: 'M23.598 5.588c-.442-.384-1.085-.564-2.081-.586-.905-.02-1.98.176-3.199.576a1.242 1.242 0 0 0-.458.292 59.062 59.062 0 0 0-3.582 3.67l-.088.097a.085.085 0 0 0-.01.098.085.085 0 0 0 .092.04l.128-.028a54.92 54.92 0 0 1 5.507-.89.427.427 0 0 1 .47.43 50.74 50.74 0 0 0 .197 5.39l.01.115a.085.085 0 0 0 .064.074l.02.004a.09.09 0 0 0 .072-.036l.066-.094a51.114 51.114 0 0 1 3.312-4.227.676.676 0 0 0 .19-.38c.369-2.358-.202-4.103-.71-4.545Z',
    }),
  );
});
robinhoodSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var robinhood = {
  category: 'brand',
  colorable: false,
  name: 'robinhood',
  svg: robinhoodSvg,
};
